import EngagementIcon from 'assets/svgs/EngagementIcon';
import SideMenuIcon from 'assets/svgs/SideMenuIcon';
import { maxWidth, primaryFont, retina, wMedium } from 'constants/utilsStyles';
import React, { useState } from 'react';
import styled from 'styled-components';
import ContactCardPopover from '../Popovers/ContactCardPopover';

const Wrapper = styled.span<{ hide?: boolean }>`
  display: ${(props) => props.hide ? 'none' : 'flex'};
  align-items: center;
  justify-content: center;
  background: #1971EB;
  padding: 2px 10px;
  border-radius: 23px;
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 16px;
  line-height: 18px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 13px;
    line-height: 16px;
  }
  color: #fff;
  .engagement-icon {
    margin-right: 5px;
  }
`;

type Props = {
  score?: number,
  showSideMenu?: boolean,
  hide?: boolean;
  contactId: number;
  index?: number;
  targetShow?: boolean,
} & typeof defaultProps;

const defaultProps = {
  showSideMenu: false,
  hide: false,
  score: null,
  index: null,
  targetShow: false,
};
const EngagementScoreWrapper = styled.div`
  display: flex;
  .side-menu-div {
    min-width: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
`;
const EngagementScorePill = function EngagementScorePill(props: Props) {
  const [visible, setVisible] = useState<boolean>(false);
  const { showSideMenu, hide, contactId, index, targetShow } = props;
  return (
    <EngagementScoreWrapper className='engagement-score-wrapper' {...(hide !== undefined ? { hide } : {})}>
      {/* <Wrapper {...(hide !== undefined ? { hide } : {})}>
        <EngagementIcon fillColor='#fff' />
        {score}
      </Wrapper> */}
      {showSideMenu ? (
        <div className='side-menu-div'>
          <ContactCardPopover contactId={contactId} toolTipShow index={index} targetShow={targetShow}>
            <div onClick={(e) => { e.stopPropagation(); setVisible(false) }}>
              <SideMenuIcon width='20' />
            </div>
          </ContactCardPopover>
        </div >
      ) : null}
    </EngagementScoreWrapper >
  );
};
EngagementScorePill.defaultProps = defaultProps;
export default EngagementScorePill;